
export const parseUrlQuery = (search:string) : {[param:string]: string} => {
    if (search == null || search === "" || search[0] !== "?") {
        return null;
    }

    search = search.substring(1);

    const ret = {};
    search.split("&").map((pair) => {
        const [name, encodedValue] = pair.split("=");
        ret[name] = decodeURIComponent(encodedValue.replace(/\+/g, '%20'));
    });
    return ret;
};

